import { render } from "./privacy_policy_ios.vue?vue&type=template&id=4dc753e6&scoped=true"
import script from "./privacy_policy_ios.vue?vue&type=script&lang=js"
export * from "./privacy_policy_ios.vue?vue&type=script&lang=js"

import "./privacy_policy_ios.vue?vue&type=style&index=0&id=4dc753e6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dc753e6"]])

export default __exports__